import { render, staticRenderFns } from "./RegistrationsByClubDetailsCard.vue?vue&type=template&id=15ce5264&"
import script from "./RegistrationsByClubDetailsCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationsByClubDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports